import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import logo from '../img/logo.svg';

function Footer() {
    return ( 
        <FooterStyled >
            <InnerLayout >
            <div className = "footer-con" >
                <div className = "logo-con" >
                    <div className = "logo-items" >
                        <img src = { logo } alt = "" />
                        <p > Copyright @2021 <a target = "_blank" href = "https://jaystance.netlify.app" > Jay Stance </a>. <br /> All rights reserved. </p> 
                    </div > 
                </div> 
            <ul className = "botton-nav" >
            <div className = "links1" >
                <li >
                    <a href = "#" > Team </a> 
                </li> 
                <li >
                    <a href = "#" > Press  </a>
                    </li> 
                    <li >
                    <a href = "#" > Fees </a> 
                </li> 
                </div> 
                <div className = "links2" >
                    <li >
                        <a href = "#" > Servics </a> 
                    </li> 
                    <li >
                        <a href = "#" > Projecs </a> 
                    </li> 
                    <li >
                        <a href = "#" > Affilite </a> 
                    </li> 
                </div> 
                <div className = "links3" >
                    <li >
                        <a href = "#" > Terms f us e </a> 
                    </li> 
                    <li >
                        <a href = "#" > Privac Policy </a> 
                    </li> 
                    <li >
                        <a href = "#" > Contac us 
                    </a> 
                    </li> 
                </div> 
        </ul> 
        </div> 
    </InnerLayout> 
    </FooterStyled>
    )
}

const FooterStyled = styled.footer `
    padding: 0 18rem;
    background-color: #DCE2F0;
    @media screen and (max-width: 1347px){
        padding: 5rem 14rem;
    }
    @media screen and (max-width: 1186px){
        padding: 5rem 8rem;
    }
    @media screen and (max-width: 990px){
        padding: 5rem 4rem;
    }
    .footer-con{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        @media screen and (max-width: 708px){
            grid-template-columns: repeat(1, 1fr);
        }
    }

    .logo-con{
        display: flex;
        align-items: center;
        img{
            width: 90px;
        }
    }

    .botton-nav{
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 708px){
            flex-direction: column;
        }
        li{
            padding: .5rem 0;
            color: #16194F;
        }
    }
`;

export default Footer